import { ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps } from '@mui/material';
import { PenSolid, Search } from '@assets/svgs';

export const ToggleFilterEditor = ({ value, onChange, ...other }: ToggleButtonGroupProps) => (
  <ToggleButtonGroup
    color='info'
    value={value}
    exclusive
    onChange={onChange}
    aria-label='filterEditor'
    {...other}
    sx={({ palette }) => ({
      '&.MuiToggleButtonGroup-root .MuiToggleButtonGroup-grouped:not(:first-of-type)': {
        borderLeft: 'none',
        marginLeft: '0px',
      },
      '& .MuiToggleButton-root': {
        border: `2px solid ${palette.secondary.main}`,
        color: palette.secondary.main,
        padding: '6px',
        backgroundColor: palette.background.main,
        '&:hover': {
          backgroundColor: palette.primary.light,
        },
        '&.Mui-selected': {
          color: palette.background.main,
          backgroundColor: palette.secondary.main,
          '&:hover': {
            backgroundColor: `${palette.secondary.main}80`,
          },
        },
      },
    })}
  >
    <ToggleButton value='toggleEditor'>
      <PenSolid height='13' width='13' />
    </ToggleButton>
    <ToggleButton value='toggleFilter'>
      <Search height='13' width='13' />
    </ToggleButton>
  </ToggleButtonGroup>
);
